import Vue from "vue";
import Router from "vue-router";
// import SimpleEdit from "@/screens/SimpleEdit";
// import JoinVideo from "@/screens/JoinVideo/JoinVideo";
// import NewsVideo from "@/screens/NewsVideo";
// import AdminDashboard from "@/screens/AdminDashboard/index.vue";
// import AutoReup from "@/screens/AutoReup";
// import CreateVoice from "@/screens/CreateVoice";
// import ExportSubtitleFromVideo from "@/screens/ExportSubtitleFromVideo";
// import ExportSubtitleFromVideoVersion2 from "@/screens/ExportSubtitleFromVideoVersion2";
// import TranslateFileSubtitle from "@/screens/TranslateFileSubtitle";
// import CaptureTextOnVideo from "@/screens/CaptureTextOnVideo";
// import FollowChannelYoutube from "@/screens/FollowChannelYoutube";
// import UserProfile from "@/screens/UserProfile/index.vue";
import store from "@/store/store";
Vue.use(Router);

// () => import('XXXXXXXXXXXX'),
export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import("@/screens/Home")
    },
    {
      path: "/pricing",
      name: "pricing",
      component: () => import("@/screens/Pricing")
    },
    {
      path: "/privacy-policy",
      name: "privacyPolicy",
      component: () => import("@/screens/Legal/PrivacyPolicy")
    },
    {
      path: "/terms-of-service",
      name: "termsOfService",
      component: () => import("@/screens/Legal/TermsOfService")
    },
    // Authentication
    {
      path: "/signin",
      name: "signin",
      component: () => {
        if (!store.state.isUserLoggedIn) {
          return import("@/screens/Signin/index")
        } else {
          return import("@/screens/Home")
        }


      }
    },
    // Manager Video
    {
      path: "/manager-video",
      name: "managerVideo",
      component: () => import("@/screens/videos/ManagerVideo"),
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) {
          next("/signin");
        } else {
          next();
        }
      }
    },
    // Workflow
    {
      path: "/workflow",
      name: "workflow",
      component: () => import("@/screens/WorkFlow"),
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) {
          next("/signin");
        } else {
          next();
        }
      }
    },
    // Simple edit video
    {
      path: "/simple-edit",
      component: () => import("@/screens/SimpleEdit"),
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) {
          next("/signin");
        } else {
          next();
        }
      }
    },
    {
      path: "/simple-edit/:id",
      component: () => import("@/screens/SimpleEdit"),
      name: "simpleEdit",
      props: true,
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) {
          next("/signin");
        } else {
          next();
        }
      }
    },
    {
      path: "/export-subtitle/:id",
      name: "exportSubtitleFromVideo",
      component: () => import("@/screens/ExportSubtitleFromVideo"),
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) {
          next("/signin");
        } else {
          next();
        }
      }
    },
    {
      path: "/news-video",
      name: "newsVideo",
      component: () => import("@/screens/NewsVideo"),
      props: route => ({
        idVideo: route.query.idvideo
      }),
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) {
          next("/signin");
        } else {
          next();
        }
      }
    },
    {
      path: "/user",
      name: "userProfileDefault",
      component: () => import("@/screens/UserProfile/index.vue"),
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) {
          next("/signin");
        } else {
          next();
        }
      }
    },
    {
      path: "/user/:screen",
      name: "userProfile",
      component: () => import("@/screens/UserProfile/index.vue"),
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) {
          next("/signin");
        } else {
          next();
        }
      }
    },
    {
      path: "/create-voice",
      name: "createVoice",
      component: () => import("@/screens/CreateVoice"),
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) {
          next("/signin");
        } else {
          next();
        }
      }
    },
    {
      path: "/read-subtitle-file",
      name: "readSubtitleFile",
      component: () => import("@/screens/ReadFileSubtitle"),
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) {
          next("/signin");
        } else {
          next();
        }
      }
    },
    {
      path: "/api-document",
      name: "apiDocument",
      component: () => import("@/screens/ApiDocument/index.vue"),
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) {
          next("/signin");
        } else {
          next();
        }
      }
    },
    {
      path: "/auto-reup",
      name: "autoReup",
      component: () => import("@/screens/AutoReup"),
      beforeEnter: (to, from, next) => {
        if (
          !store.state.isUserLoggedIn ||
          (store.state.user.type != "admin" &&
            store.state.user.type != "TEAM_MEMBER")
        ) {
          next("/signin");
        } else {
          next();
        }
      }
    },
    // Admin
    {
      path: "/admin",
      name: "adminDashboard",
      component: () => import("@/screens/AdminDashboard/index.vue"),
      beforeEnter: (to, from, next) => {
        if (!store.state.user || store.state.user.username != "admin") {
          next("/");
        } else {
          next();
        }
      }
    },

    {
      path: "/translate-file-subtitle",
      name: "TranslateFileSubtitle",
      component: () => import("@/screens/TranslateFileSubtitle"),
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) {
          next("/signin");
        } else {
          next();
        }
      }
    },
    {
      path: "/capture-text-video",
      name: "CaptureTextOnVideo",
      component: () => import("@/screens/CaptureTextOnVideo"),
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) {
          next("/signin");
        } else {
          next();
        }
      }
    },
    {
      path: "/follow-channel-youtube",
      name: "FollowChannelYoutube",
      component: () => import("@/screens/FollowChannelYoutube"),
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) {
          next("/signin");
        } else {
          next();
        }
      }
    },
    {
      path: "/youtube-tracker",
      name: "YoutubeTracker",
      component: () => import("@/screens/YoutubeTracker"),
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) next("/signin");
        else next();
      }
    },
    {
      path: "/video-library",
      name: "videoLibrary",
      component: () => import("@/screens/VideoLibrary"),
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) next("/signin");
        else next();
      }
    },
    {
      path: "/google-assets",
      name: "googleAssets",
      component: () => import("@/screens/GoogleAssets"),
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) next("/signin");
        else next();
      }
    },
    {
      path: "/get-comment-yahoo",
      name: "GetCommentYahoo",
      component: () => import("@/screens/GetCommentYahoo"),
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) {
          next("/signin");
        } else {
          next();
        }
      }
    },
    {
      path: "/create-video-news",
      name: "createVideoNews",
      component: () => import("@/screens/VideoNewsProshowCapcut"),
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) {
          next("/signin");
        } else {
          next();
        }
      }
    }
    ,
    {
      path: "/create-video-reup",
      name: "createVideoReup",
      component: () => import("@/screens/VideoReup"),
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) next("/signin");
        else next();
      }
    }
    ,
    {
      path: "/export-subtitle-audio/:id",
      name: "exportSubtitleFromAudio",
      component: () => import("@/screens/ExportSubtitleFromAudio"),
      beforeEnter: (to, from, next) => {
        if (!store.state.isUserLoggedIn) {
          next("/signin");
        } else {
          next();
        }
      }
    },


  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js